import React from "react";
import { Link } from "react-router-dom";
import "./home.css";
import SimpleServiceCard from "../global/SimpleServiceCard";

// Images
import truck1 from "../../assets/images/Home/refrigerated-delivery-truck.webp";
import van1 from "../../assets/images/Home/chiller-van-for-refrigerated-transport.webp";
import freezerTruck from "../../assets/images/Home/freezer-truck-service-chiller-van.webp";
import freezerVan from "../../assets/images/Home/insulated-freezer-van-interior-chill-freezer.webp";
import highRoofVan from "../../assets/images/Home/high-roof-van-service-chiller-dubai-sharjah-rent-freeze.webp";
import refrigeratedTruck from "../../assets/images/Home/refrigerated-truck-service-chiller-freeze.webp";

// Routes mapping
const servicesPaths = {
  "Chiller Truck": "/services/chiller-trucks",
  "Chiller Van": "/services/chiller-vans",
  "Freezer Truck": "/services/freezer-trucks",
  "Freezer Van": "/services/freezer-vans",
  "High Roof Van": "/services/high-roof-vans",
  "Refrigerated Truck": "/services/refrigerated-trucks",
};

// Slider data
const experienceItems = [
  {
    title: "Chiller Van for Rent",
    img: van1,
    link: "/chiller-van-for-rent",
    desc: "For fast-moving urban deliveries across Dubai, Our chiller van for rent  handles chilled goods that require controlled temperatures during short-distance transport and are commonly selected for daily distribution cycles involving dairy products, beverages, and fresh retail supplies, where multiple stops and tight delivery schedules are part of the operation.",
  },
  {
    title: "Freezer Van Rental",
    img: freezerVan,
    link: "/freezer-van-for-rent",
    desc: "Our Freezer vans for rent in Dubai are ideal for frozen goods movement within city routes where temperature stability must remain consistent throughout short-haul transport, typically used when transporting meat, poultry, and frozen packaged items from storage facilities to retail outlets under strict freezing conditions.",
  },
  {
    title: "Chiller Truck Rental",
    img: truck1,
    link: "/chiller-truck-for-rent",
    desc: "Chiller trucks are provided for rent when logistics operations require consolidated chilled shipments across warehouses, supermarkets, and retail distribution points. Our chiller trucks cover medium-scale movement where multiple cargo loads are combined into a single delivery cycle to improve distribution efficiency across the regional routes.",
  },
  {
    title: "Freezer Truck for Rent",
    img: freezerTruck,
    link: "/freezer-truck-for-rent",
    desc: "For large-scale frozen logistics operations, Chiller fleet transport offers freezer trucks rental services in Dubai to handle bulk transport under stable sub-zero conditions. This category is used in structured supply chains handling high-volume frozen goods such as seafood, ice cream products, and dairy products across extended delivery routes within the UAE.",
  },
  {
    title: "High Roof Dry Van",
    img: highRoofVan,
    link: "/high-roof-dry-van-for-rent",
    desc: "The High roof dry vans for rent in Dubai are used for general cargo movement, making them suitable for packaged goods, cartons, and commercial shipments. Our tall-roof vans are commonly used when cargo volume and space utilization are more important than environmental conditions during transportation.",
  },
  {
    title: "Refrigerated Truck Rental",
    img: refrigeratedTruck,
    link: "/refrigerated-trucks-for-rent",
    desc: "Refrigerated trucks are provided for rent in Dubai for high-capacity logistics operations involving large-volume chilled and frozen goods distribution. This category supports centralized supply chain movement and inter-emirate transport routes where maintaining controlled temperature conditions across heavy payloads usually ranging from 10 tons to 15 tons is required.",
  },
];

const HomeFleet = () => {
  return (
    <section className="container-fluide mt-5 py-5 bg-light">
      <div className="container">
        <div className="chiller_fleetslider-simple-content-header" data-aos="fade-up" data-aos-delay="300">
          <h2 className="h2-title text-center">Our Fleet Structure for Refrigerated and Cargo Transport in Dubai</h2>
          <p className="py-3 text-center">We provide structured vehicles for rent in Dubai, organized around delivery distance, load size, and temperature requirements. Instead of a one-size vehicle approach, the fleet is deployed based on logistics decision factors such as urgency, cargo sensitivity, and distribution scale across urban and inter-emirate routes.</p>
        </div>

        <div className="home-fleet" data-aos="zoom-in" data-aos-delay="400">
          {experienceItems.map((item, index) => (
            // From Common Dynamic Component
            <SimpleServiceCard
              key={index}
              img={item.img}
              title={item.title}
              desc={item.desc}
              link={item.link}
              buttonGroup={
                <>
                  <a href="tel:+971544792905" className="btn--primary">Call Now</a>
                  <a
                    href={`https://wa.me/971544792905?text=Hi I want to book ${item.title}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn--primary bg-light text-dark"
                  >Book Now</a>
                </>
              }
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default HomeFleet;